import { SettingsDisplayPage } from "@/components/settings/display/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/display")({
  component: SettingsDisplayPage,
});
